import { TagDetails } from '@/types';

export function getExpireOnTagDetail(expireOn: number): TagDetails {
  return expireOn < Date.now()
    ? {
        text: 'Expired',
        icon: 'mdi-calendar-alert',
      }
    : {
        text: new Date(expireOn).toLocaleDateString(),
        icon: 'mdi-calendar-clock',
      };
}
